import { __awaiter } from "tslib";
import { logger } from '@lusha/client-logger';
import { getCreditsBalance } from '../../API/accountAssetsApi';
import { getAccountIntegrations } from '../../API/integrationsAPI';
import { fetchAccountIntentTopics } from '../../API/intent';
import { CREDIT_TYPES } from '../../utils/constants';
import { delay } from '../../utils/delay';
import { selectHasAccessToIntentFeature, selectHasIntegrationPermissions } from '../user/selectors';
import { actions } from './reducer';
let latestCreditsRequest = 0;
class Dispatcher {
    constructor() {
        this.actions = actions;
    }
    fetchAccountCredits(numberOfCreditsCharged = 0) {
        return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!((_a = envConfig.FEATURES) === null || _a === void 0 ? void 0 : _a.FREE_TRIAL_POPUP))
                return;
            try {
                const reqId = ++latestCreditsRequest;
                const { totalCredits } = getState().account;
                const nextTotalCredits = totalCredits - numberOfCreditsCharged;
                if (nextTotalCredits >= 0) {
                    dispatch(actions.setTotalCredits(nextTotalCredits));
                }
                // We have a delay here because sometimes BE takes more then 5s to update values fot /balance API
                if (numberOfCreditsCharged) {
                    yield delay(8000);
                }
                if (reqId !== latestCreditsRequest)
                    return;
                const res = yield getCreditsBalance();
                if (reqId !== latestCreditsRequest)
                    return;
                const { shared = [] } = res || {};
                dispatch(actions.setAccountCreditsTypes(shared));
                shared.forEach(({ totalUsed, total, type }) => {
                    if (type !== CREDIT_TYPES.EMAIL && type !== CREDIT_TYPES.PHONE) {
                        dispatch(actions.setPlanCredits({ totalCredits: total - totalUsed, userPlanTotalCredits: total }));
                    }
                });
            }
            catch (err) {
                if (err.code !== 401) {
                    logger.error('Failed to fetch account balances', {
                        code: err === null || err === void 0 ? void 0 : err.code,
                        httpStatus: err === null || err === void 0 ? void 0 : err.httpStatus,
                        status: err === null || err === void 0 ? void 0 : err.status,
                        message: err === null || err === void 0 ? void 0 : err.message,
                        statusText: err === null || err === void 0 ? void 0 : err.statusText,
                        stack: err === null || err === void 0 ? void 0 : err.stack,
                    });
                }
            }
        });
    }
    fetchAccountIntegrations() {
        return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
            const { user } = getState();
            if (!selectHasIntegrationPermissions(user)) {
                return;
            }
            try {
                const accountIntegrations = yield getAccountIntegrations();
                dispatch(actions.setIntegrations(accountIntegrations));
            }
            catch (error) {
                logger.error(`Failed to fetch account integrations: ${JSON.stringify(error)}`, {
                    accountId: user.accountId,
                    userId: user.id,
                    error,
                });
            }
        });
    }
    fetchAccountIntentTopics() {
        return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { user, account } = getState();
            if (account.isIntentTopicsLoaded || !selectHasAccessToIntentFeature(user)) {
                return;
            }
            try {
                const response = yield fetchAccountIntentTopics();
                dispatch(actions.setIntentTopics((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : []));
            }
            catch (error) {
                logger.error('Failed to fetch intent account topics', { error, userId: user.id, accountId: user.accountId });
                dispatch(actions.setIntentTopics(undefined));
            }
        });
    }
}
const AccountDispatcher = new Dispatcher();
export default AccountDispatcher;
